import Vue from "vue"
const monthNames = ["Януару", "Февруари", "Март", "Април", "Май", "Юни", "Юли", "Август", "Септември", "Октомвеу", "Ноевмри", "Декември"];
const dayNames = ["Неделя","Понеделник", "Вторник", "Сряда", "Четвъртък", "Петък", "Събота"];


Vue.mixin({
  methods: {
    avatarSrc: avatar => (typeof avatar === 'string' || avatar === null) ? avatar : avatar.encoded,
    getDate: date => new Date(date.replace(/-/g, "/")),
    localDate: date => new Date(date.replace(/-/g, "/")).toLocaleString('bg-BG'),
    localMonth: date => monthNames[new Date(date.replace(/-/g, "/")).getMonth()],
    localDay: date => dayNames[new Date(date.replace(/-/g, "/")).getDay()],
    standalone: () => {
      let isInWebAppiOS = (window.navigator.standalone === true)
      let isInWebAppChrome = (window.matchMedia('(display-mode: standalone)').matches)

      return isInWebAppiOS || isInWebAppChrome
    },
    getIcon(quizName){
      let res;
      try {
        res = require('@/assets/'+quizName.toLowerCase().replace(' ','_')+'.png');
      } catch (e) {
        if (e.code !== 'MODULE_NOT_FOUND') {
          throw e;
        }
        res = '/img/icons/android-chrome-maskable-512x512.png';
      }

      return res;
    },

    maximizeRatePanel: () => {
      //console.log(this.$mq)
    },
    // logoStar:()=>{
    //   return require('@/assets/logo-star.svg');
    // }
  }
})
